import { gql, useQuery } from '@apollo/client';
import { Purchase } from 'apollo/generated/types';

interface QueryGetPurchaseStatusArgs {
  uuid: string;
}

const GET_PURCHASE_STATUS = gql`
  query getPurchaseStatus($uuid: ID!) {
    getPurchaseStatus(uuid: $uuid) {
      id
      state
    }
  }
`;

const useGetPurchaseStatusQuery = (uuid: string, skip: boolean) => {
  return useQuery<{ getPurchaseStatus: Purchase }, QueryGetPurchaseStatusArgs>(
    GET_PURCHASE_STATUS,
    {
      variables: { uuid },
      skip,
      fetchPolicy: 'no-cache',
    }
  );
};

export default useGetPurchaseStatusQuery;
